import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KInfo from 'app/components/Modules/DataDisplay/KInfo'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { Link } from 'react-router-dom'

const Tooltip: React.FC<MemberProps<IProject>> = ({ member }) => {
  const { tRecordType } = useTranslation({ recordType: RecordTypeEnum.project })

  return (
    <Row gutter={[0, 0]} className="bg-white">
      <KCol span={24}>
        <h5 className="mb-0">
          <Link to={Routes.Project.member(member.id.toString()).show} type="link">
            {member.name}
          </Link>
        </h5>
      </KCol>
      <KCol span={24}>
        <KInfo
          size="small"
          recordType={RecordType.project}
          member={{
            name: member.name,
            status: tRecordType({ id: `stage_info.${member.stage}` }),
            time_period: `${member.start_date} - ${member.end_date}`
          }}
        />
      </KCol>
    </Row>
  )
}

export default Tooltip
